module.exports = __webpack_public_path__ + "static/media/Icono almacenamiento.ce446328.svg";